"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormDatosGenerales = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _getSelectOptions = require("../../utils/getSelectOptions");

var _FormLinksPropiedad = _interopRequireDefault(require("../FormLinksPropiedad"));

var _Select = _interopRequireDefault(require("../../dist/Select"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class FormDatosGenerales extends _react.default.Component {
  constructor(props) {
    super(props);
    this.onBlurInput = this.onBlurInput.bind(this);
    this.onChangeCheck = this.onChangeCheck.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.handleTooltipOpen = this.handleTooltipOpen.bind(this);
    this.handleTooltipClose = this.handleTooltipClose.bind(this);
    this.state = {
      openTooltip: false
    };
  }

  onBlurInput(event) {
    const value = event.target.value;
    const dato = event.target.getAttribute('data-estado');
    this.props.onChange(value, dato);
  }

  onChangeCheck(event) {
    this.props.onChange(event.target.checked ? 1 : 0, 'habilitacion_municipal');
  }

  onChangeSelect(event) {
    this.props.onChange(event.target.value, event.target.name);
  }

  handleTooltipOpen() {
    this.setState({
      openTooltip: true
    });
  }

  handleTooltipClose() {
    this.setState({
      openTooltip: false
    });
  }

  render() {
    const {
      facebook,
      instagram,
      tripadvisor,
      pagina_web,
      acceso_rapido,
      habilitacion_municipal,
      nombre_fantasia,
      es_siro,
      tieneUnaUnidad,
      tipo,
      capacidad,
      dormitorios,
      banios,
      codigo_habilitacion,
      isMobile
    } = this.props;
    return (0, _react2.jsx)("div", {
      css: _style.default.root
    }, (0, _react2.jsx)(_material.Grid, {
      container: true
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12
    }, (0, _react2.jsx)(_material.FormControl, {
      fullWidth: true,
      "aria-describedby": "nombre-fantasia-text"
    }, (0, _react2.jsx)(_material.InputLabel, {
      htmlFor: "nombre-fantasia"
    }, "Nombre de Fantas\xEDa"), (0, _react2.jsx)(_material.Input, {
      onBlur: this.onBlurInput,
      defaultValue: nombre_fantasia,
      placeholder: "Ej: Caba\xF1a La Esperanza",
      inputProps: {
        'data-estado': 'nombre_propiedad'
      }
    }))), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      css: _style.default.container
    }, (0, _react2.jsx)(_Select.default, {
      name: "id_tipo",
      placeholder: "Tipo de alojamiento",
      value: tipo !== null ? tipo : [],
      onChange: this.onChangeSelect,
      nameOfTheKeyWithTheValue: "value",
      nameOfTheKeyWithTheLabel: "label",
      data: _getSelectOptions.selectTipo
    }), tieneUnaUnidad ? (0, _react2.jsx)(_react.default.Fragment, null, (0, _react2.jsx)(_Select.default, {
      name: "capacidad_max",
      placeholder: "Capacidad m\xE1xima",
      value: capacidad !== null ? capacidad : [],
      onChange: this.onChangeSelect,
      nameOfTheKeyWithTheValue: "value",
      nameOfTheKeyWithTheLabel: "label",
      data: _getSelectOptions.selectCapacidad
    }), (0, _react2.jsx)(_Select.default, {
      name: "dormitorios",
      placeholder: "Dormitorios",
      value: dormitorios !== null ? dormitorios : [],
      onChange: this.onChangeSelect,
      nameOfTheKeyWithTheValue: "value",
      nameOfTheKeyWithTheLabel: "label",
      data: _getSelectOptions.selectDormitorios
    }), (0, _react2.jsx)(_Select.default, {
      name: "ba\xF1os",
      placeholder: "Ba\xF1os",
      value: banios !== null ? banios : '',
      onChange: this.onChangeSelect,
      nameOfTheKeyWithTheValue: "value",
      nameOfTheKeyWithTheLabel: "label",
      data: _getSelectOptions.selectBano
    })) : null)), (0, _react2.jsx)("div", {
      css: _style.default.check
    }, (0, _react2.jsx)(_material.FormControlLabel, {
      label: "Habilitaci\xF3n Municipal",
      control: (0, _react2.jsx)(_material.Checkbox, {
        checked: !!habilitacion_municipal,
        onChange: this.onChangeCheck,
        value: "es_habilitado_municipal",
        color: "primary"
      })
    }), (0, _react2.jsx)(_material.FormControl, null, (0, _react2.jsx)(_material.Input, {
      defaultValue: codigo_habilitacion,
      disabled: !habilitacion_municipal,
      onBlur: this.onBlurInput,
      inputProps: {
        'data-estado': 'numero_habilitacion'
      },
      placeholder: "C\xF3digo de habilitaci\xF3n"
    }))), !es_siro ? (0, _react2.jsx)(_react.default.Fragment, null, (0, _react2.jsx)(_material.Typography, {
      variant: "subtitle1"
    }, "Pega tus Links"), (0, _react2.jsx)(_FormLinksPropiedad.default, {
      facebook: facebook,
      instagram: instagram,
      tripadvisor: tripadvisor,
      pagina_web: pagina_web,
      acceso_rapido: acceso_rapido,
      openTooltip: this.state.openTooltip,
      onBlurInput: this.onBlurInput,
      handleTooltipOpen: this.handleTooltipOpen,
      handleTooltipClose: this.handleTooltipClose,
      isMobile: isMobile
    })) : null);
  }

}

exports.FormDatosGenerales = FormDatosGenerales;
var _default = FormDatosGenerales;
exports.default = _default;